/**
 * WP-3 — de onboardinggate.
 *
 * Eén vraag: moet deze gebruiker eerst de onboarding afronden voordat hij de
 * applicatie in mag? De beslissing staat bewust in een pure functie, los van de
 * router, zodat ze toetsbaar is zonder een browser.
 *
 * Onbekende status toont een herstelpagina in OnboardingGate. Platformbeheer
 * kan alleen de aangewezen voorbereiding openen voordat de klant aanvaardt.
 * Bestaande tenants krijgen geen nieuwe aanvaardingsplicht door deze overgang.
 */

/** Pad van de onboardingpagina. Eén plek, zodat gate en router niet uiteenlopen. */
export const ONBOARDING_PAD = "/app/onboarding";

export type OnboardingToestand =
  | { soort: "legal-open" }
  /** We weten het nog niet: aan het laden, of de bevraging faalde. */
  | { soort: "onbekend" }
  /**
   * Zuivere platformcontext: beheerdersrol zonder gekozen tenant. Er is hier geen
   * klant die iets aanvaardt, dus er valt niets af te ronden.
   */
  | { soort: "platformcontext" }
  | { soort: "bestaande-toegang" }
  /** Expliciet oordeel uit de database. */
  | { soort: "bekend"; voltooidOp: string | null };

export function isOnboardingVoltooid(toestand: OnboardingToestand): boolean {
  return toestand.soort === "bekend" && toestand.voltooidOp !== null;
}

/**
 * Moet de gebruiker naar de onboarding worden gestuurd?
 *
 * @param toestand  wat we van de tenant weten
 * @param huidigPad het pad waar de gebruiker nu heen wil
 */
export const VOORBEREIDING_PADEN = [
  "/app/platform", "/app/internal/platform", "/app/activatiecentrum", "/app/startklaar",
  "/app/instellingen", "/app/recovery-designer", "/app/opdrachtgevers",
] as const;

export function magCollectrVoorbereiden(pad: string): boolean {
  return VOORBEREIDING_PADEN.some(prefix => pad === prefix || pad.startsWith(`${prefix}/`));
}

export function moetNaarOnboarding(toestand: OnboardingToestand, huidigPad: string, collectrVoorbereiding = false): boolean {
  // "onbekend" en "platformcontext" sturen allebei niemand weg, om verschillende
  // redenen: het eerste omdat we het niet weten, het tweede omdat er niets te
  // onboarden valt.
  if (toestand.soort !== "bekend") return false;
  if (toestand.voltooidOp !== null) return false;
  if (collectrVoorbereiding && magCollectrVoorbereiden(huidigPad)) return false;
  // De onboardingpagina en alles eronder blijven bereikbaar.
  if (huidigPad === "/app/activatiecentrum" || huidigPad === "/app/startklaar") return false;
  if (huidigPad === ONBOARDING_PAD || huidigPad.startsWith(`${ONBOARDING_PAD}/`)) return false;
  return true;
}
